import React, { useState } from 'react';
import { FileText, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { withCsv } from '@/lib/downloadFormat';

// Sibling of an existing "Excel" button: runs the same download handler but saves CSV.
export const CsvDownloadButton = ({ onDownload, label = 'CSV', testId, disabled, size = 'sm', className = '' }) => {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try { await withCsv(onDownload); } finally { setBusy(false); }
  };
  return (
    <Button type="button" variant="outline" size={size} onClick={run} disabled={disabled || busy}
      className={`gap-1.5 ${className}`} data-testid={testId} title="Download as CSV (multi-sheet reports come as a ZIP of CSVs)">
      {busy ? <Loader2 size={14} className="animate-spin" /> : <FileText size={14} />}
      {label}
    </Button>
  );
};

export default CsvDownloadButton;
